
const digest = '830fda15733242abac36610bac70b5aedf5705eb03f6a99f79b454b353018ad1';
const css = `._wordCountContainer_8si3i_1 {
  width: 300px;
  max-width: 100%;
  font-size: var(--font-size-100);
}

._wordCountRow_8si3i_7 {
  display: flex;
  justify-content: space-between;
  padding: var(--spacer-3) 0;
}

._wordCountRow_8si3i_7 ~ ._wordCountRow_8si3i_7 {
  border-top: 1px solid var(--theme-primary-border);
}

._wordCount_8si3i_1 {
  margin-right: var(--spacer-3);
}

._count_8si3i_21 {
  font-weight: 600;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"wordCountContainer":"_wordCountContainer_8si3i_1","wordCountRow":"_wordCountRow_8si3i_7","wordCount":"_wordCount_8si3i_1","count":"_count_8si3i_21"};
export { css, digest };
  